// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"slider_wrapper__3lAC-","preview":"slider_preview__3R5nN","slider":"slider_slider__3epgx"};